<!-- <div *ngIf="!dashboardAccess">
<h1 style="color: #499;text-align: center;font-size: xxx-large;">Welcome To</h1>
<h1 style="color: #499;text-align: center;font-size: xxx-large;">Bandhan Health Program</h1>
</div> -->

<!-- If dashboard is given access 'Yes' -->
<div *ngIf="isDashboardAccessible === 'Y'">
  <div class="example-card">
    <div class="mat-card">
      <div class="example-header-image">
        <div class="icons">
          <img src="assets/Donate-1.svg" style="width: 35px;" />
        </div>
        <h4>Donor : {{ totalDonor }}</h4>
      </div>
    </div>
    <div class="mat-card">
      <div class="example-header-image">
        <div class="icons"><i class="fa fa-file-text-o fa-2x"></i></div>
        <h4>Project : {{ totalProjectMasterId }}</h4>
      </div>
    </div>
    <div class="mat-card">
      <div class="example-header-image">
        <div class="icons"><i class="fas fa-code-branch fa-2x"></i></div>
        <h4>Branch : {{ totalBranch }}</h4>
      </div>
    </div>
    <div class="mat-card">
      <div class="example-header-image">
        <div class="icons">
          <i class="fa fa-map-marker fa-2x"></i>
        </div>
        <h4>Region : {{ totalRegion }}</h4>
      </div>
    </div>
  </div>
  <br />
  <div class="example-card">
    <div class="mat-card">
      <div class="example-header-image">
        <div class="icons"><i class="fa fa-university fa-2x"></i></div>
        <h4>State : {{ totalStateName }}</h4>
      </div>
    </div>
    <div class="mat-card">
      <div class="example-header-image">
        <div class="icons"><i class="fa fa-building fa-2x"></i></div>
        <h4>District : {{ totalDistrict }}</h4>
      </div>
    </div>
    <div class="mat-card">
      <div class="example-header-image">
        <div class="icons"><i class="fa fa-cubes fa-2x"></i></div>
        <h4>Block : {{ totalBlock }}</h4>
      </div>
    </div>
    <div class="mat-card">
      <div class="example-header-image">
        <div class="icons">
          <img src="assets/village.svg" style="width: 35px;" alt="Poop Logo" />
        </div>
        <h4>Village : {{ totalVillageLocality }}</h4>
      </div>
    </div>
  </div>

  <br />
  <div style="display: flex; margin: 10px 30px 5px 10px">
    <div class="chartbox">
      <div [hidden]="loader" style="margin: -125px 34%; margin-top: 20%">
        <div class="spinner-grow text-danger" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        &nbsp;&nbsp;
        <div class="spinner-grow text-warning" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        &nbsp;&nbsp;
        <div class="spinner-grow text-info" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <canvas id="myChart1" #mychart1></canvas>
      <p style="margin: 8px 35%; color: black; font-weight: 400; font-size: 16px">
        Family Information
      </p>
      <div class="downloadrefreshicon">
        <i class="fa fa-download fa-lg" title="Download Chart"
          (click)="download('myChart1', 'Family Information Chart')"></i>&nbsp;&nbsp;
        <i class="fa fa-refresh fa-lg" title="Refresh Chart" (click)="refreshChart()"></i>
      </div>
    </div>

    &nbsp;&nbsp;&nbsp;&nbsp;
    <div class="chartbox">
      <div [hidden]="loader" style="margin: -125px 34%; margin-top: 20%">
        <div class="spinner-grow text-danger" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        &nbsp;&nbsp;
        <div class="spinner-grow text-warning" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        &nbsp;&nbsp;
        <div class="spinner-grow text-info" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <canvas id="myChart2" #mychart2></canvas>
      <p style="margin: 8px 35%; color: black; font-weight: 400; font-size: 16px">
        Child Information
      </p>
      <div class="downloadrefreshicon">
        <i class="fa fa-download fa-lg" title="Download Chart"
          (click)="download('myChart2', 'Child Information Chart')"></i>&nbsp;&nbsp;
        <i class="fa fa-refresh fa-lg" title="Refresh Chart" (click)="refreshChart()"></i>
      </div>
    </div>
  </div>
</div>

<!-- If dashboard is given access 'No' -->
<div *ngIf="isDashboardAccessible == 'N'">

  <section class="bhp-modern">
    <!-- Background Image -->
    <div class="bhp-bg"></div>

    <!-- Floating Description Card -->
    <div class="bhp-content-card">
      <h2>Bandhan Health Programme (BHP)</h2>
      <p>
        This programme aims to increase health awareness with the goal of improved health
        and wellbeing of underprivileged families. It gives special focus on under-5 children,
        pregnant women, lactating mothers and adolescent girls regarding safe motherhood,
        child nutrition, personal hygiene and sanitation issues.
      </p>
      <p>
        Under this initiative, health volunteers are developed by selecting interested women
        from the villages and providing them adequate training. These health volunteers are
        called <strong>Swasthya Sahayika (SS)</strong> who work in the villages to impart
        health education through regular health forums and household visits under the
        guidance of health staff members. The volunteers distribute health kits at the
        doorstep, comprising commonly used medicines. They also provide linkage/referral
        services.
      </p>
    </div>
  </section>


</div>